import React, { useEffect, useState } from "react";
import fetchData from "../../api/fetchApi";
import Table from "../common/Table";

export default function NewComersListReport() {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalMembers, setTotalMembers] = useState(0);
  const [filters, setFilters] = useState({
    name: "",
    email: "",
    mobile: ""
  });

  const fetchMembers = async () => {
    setLoading(true);
    setError(null);
    try {
      let query = `chaat/members/reports/new_comers?page=${currentPage}&per_page=${perPage}`;
      if (filters.name) query += `&filter[name]=${encodeURIComponent(filters.name)}`;
      if (filters.email) query += `&filter[email]=${encodeURIComponent(filters.email)}`;
      if (filters.mobile) query += `&filter[mobile]=${encodeURIComponent(filters.mobile)}`;
      const data = await fetchData(query);
      setMembers(data.data || []);
      setTotalMembers(data.meta?.total || 0);
      setCurrentPage(data.meta?.current_page || 1);
      setTotalPages(data.meta?.last_page || 1);
    } catch (err) {
      setError(err.message || "حدث خطأ أثناء جلب البيانات");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMembers();
    // eslint-disable-next-line
  }, [currentPage, perPage, filters]);

  const onFilter = () => {
    setCurrentPage(1);
    fetchMembers();
  };

  const columns = [
    { header: "المعرف", accessor: "id" },
    { header: "الاسم", accessor: "name" },
    { header: "البريد الإلكتروني", accessor: "email" },
    { header: "رقم الهاتف", accessor: "mobile" },
    { header: "تاريخ الإضافة", accessor: "add_date" },
    { header: "الحالة", accessor: "status", render: row => row.status === "1" ? "نشط" : "غير نشط" },
    { header: "تاريخ الانتهاء", accessor: "expired_date_at" },
  ];

  return (
    <div className="bg-white rounded-xl shadow p-6 mb-6">
      <h2 className="font-bold text-xl mb-4">قائمة الأعضاء الجدد</h2>
      <Table
        columns={columns}
        rows={members}
        filters={filters}
        setFilters={setFilters}
        onFilter={onFilter}
        pagination={{
          title: "الأعضاء الجدد",
          label: `الصفحة ${currentPage} من ${totalPages}`,
          pages: Array.from({ length: totalPages }, (_, i) => i + 1),
          current: currentPage,
          last: totalPages,
          onPageChange: setCurrentPage,
          perPage: perPage,
          onPerPageChange: setPerPage,
        }}
      />
      {loading && <div className="text-center mt-4">جاري التحميل...</div>}
      {error && <div className="text-red-600 text-center mt-4">{error}</div>}
    </div>
  );
}
